export default "__VITE_ASSET__01be0982__"